
import { defineComponent } from "vue";

export default defineComponent({
  name: "OutlineControl",
  props: {
    collapsed: {
      type: Boolean,
      required: true,
    },
  },
});
